<div class="page-container primary h-100 d-flex flex-column flex-nowrap justify-content-between hidden-scroll" >

   <div class="left-space-container h-100 d-flex flex-column flex-nowrap"
      [ngClass]="(header.activePage == 'smart-thermo') || (header.activePage == 'smart-camera') ? 'two-color-background' : 'bg-standard'">
    <header *ngIf="(header.question || header.showSubtitle || header.showSubtitleInfo || header.showAddonTitle) && (header.activePage != 'smart-thermo' && header.activePage != 'smart-camera') && (cs ? cs.showHeaderPage : true)">
      <div class="row" *ngIf="header.showAddonTitle">
        <div class="p-x-page p-t-page">
          <h6 class="m-y-0 addon-title" [innerHTML] = "header.addonTitle | translate"></h6>
        </div>
      </div>
        <div class="row" *ngIf="header.question">
          <div class="p-x-page p-t-page-title">
            <h1 class="m-y-0" [innerHTML]= "header.question | translate"></h1>
          </div>
        </div>
        <div class="row d-flex p-x-page m-subtitle align-items-center" *ngIf="header.showSubtitle"
        >
          <div class="d-inline-flex"
            *ngIf="header.showSubtitle"
          >
            <div>
              <h6 class="font-weight-normal m-y-0 subtitle" [innerHTML]="header.subtitle | translate"></h6>
            </div>
          </div>
        </div>
        <div class="row d-flex p-x-page align-items-left m-t-16" *ngIf="header.showSubtitleInfo">
            <button
              mat-flat-button
              class="bticino-ico guide-button"
              style="width: 190px; height: 48px"
              (click)="onSubTitleInfoClick()"
            >
            <span class="bticino-ico guide"></span>
            <span class="font-guide-button m-l-8">{{header.subtitleInfo  | translate }}</span>
            </button>
        </div>
    </header>

    <main
      (scroll)="onScrollMain()"
      class="h-100"
    >
      <div
        [ngClass]="{'center-content': header.centerContent}"
        [@routeSlide]="routeIndex"
        class="h-100"
        [ngClass]="(header.activePage == 'smart-thermo') || (header.activePage == 'smart-camera') ? 'base-container' : ''"
      >
        <router-outlet #o="outlet" (activate)="onActivate($event)"></router-outlet>
      </div>
    </main>
  </div>
    <footer *ngIf="cs ? cs.showFooter : true"
      [ngClass]="footer ? footer.customClass : ''"
    >
        <div class="custom-progressive-scroll bar-height">
          <div id="progressIndicator" class="indicator animated"></div>
        </div>
        <div
          class="action-container footer-content-from-bar-height d-flex align-items-center justify-content-end p-l-logo-specular"
         ><!--[ngClass]="{'center-buttons': footer.sendBtnVisible}" -->

            <div class="tooltip-toggler-transparent" *ngIf="footer ? footer.tooltip && !footer.nextBtnEnabled && !footer.sendBtnEnabled : false"
                #tooltipRef [appTooltipToggler]="tooltipRef" [tooltipText]="footer.tooltip"></div>

              <button mat-flat-button
                id="backButton"
                (click)="onClickBackButton()"
                *ngIf="footer ? footer.backBtnVisible : false"
                class="back-button small-padding cta">
                <span class="text-uppercase">{{ 'b2c.IDS_BACK' | translate }}</span>
              </button>

              <button mat-flat-button
                id="confirmBtn"
                (click)="confirmBtnClick()"
                *ngIf="footer ? footer.nextBtnVisible : false"
                [disabled]="footer ? !footer.nextBtnEnabled : true"

                color="primary"
                class=" cta animated mat-secondary small-padding secondary"
                [ngClass]="{'continue-button': footer.nextBtnEnabled}">
                  <span class="text-uppercase">
                    {{ 'b2c.IDS_CONFIRM' | translate }}
                  </span>
                  &nbsp;
                  <span class="bticino-ico arrow-right white" style="width: 24px; height: 24px;"></span>
              </button>

              <button mat-flat-button
                id="sendBtn"
                *ngIf="footer ? footer.sendBtnVisible : false" [disabled]="footer ? !footer.sendBtnEnabled : true"
                (click)="sendBtnClick()"
                [eventTracker]="analyticsCall()"
                color="primary"
                class="cta animated mat-secondary small-padding secondary"
              >
                <span class="text-uppercase">
                  {{ 'IDS_SEND' | translate }}
                </span>
                &nbsp;
                <span class="bticino-ico paper-airplane white" ></span>
              </button>

              <button mat-flat-button
                id="sendInstallerBtn"
                *ngIf="footer ? footer.sendInstallerBtnVisible : false" [disabled]="footer ? !footer.sendInstallerBtnEnabled : true"
                (click)="sendInstallerBtnClick()"
                [eventTracker]="analyticsCall()"
                color="primary"
                class="cta animated mat-secondary small-padding secondary"
              >
                <span class="text-uppercase">
                  {{ 'IDS_SEND' | translate }}
                </span>
                &nbsp;
                <span class="bticino-ico paper-airplane white" ></span>
              </button>

              <button mat-flat-button
                *ngIf="footer ? footer.backHomeBtnVisible : false"
                id="backHomeBtn"
                (click)="backHomeBtnClick()"
              >{{ 'b2c.IDS_BACKHOME' | translate }}
              </button>
        </div>
    </footer>
</div>

<div id="loaderContainer" *ngIf="cs.showLoader" >
    <div class="loader">
        <img src="../assets/video/loader.gif">
        <!-- <img src="../assets/img/loader.gif" > -->
        <span>{{ loadingMessage }}</span>
    </div>
</div>

<app-tooltip></app-tooltip>